import profile  from "./user-profile.jpg";

export default {
    profile
}